// hooks
import { useEffect, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// styles
import { HeaderContainer } from './FormHeader.styles';

// types
import { AppointmentFormFieldData } from '../../AppointmentForm.types';

// components
import { Typography } from '@mui/material';

// utils
import dayjs from 'dayjs';

const FormHeader = () => {
  const { t } = useTranslation('common', { keyPrefix: 'mrp.appointmentForm' });
  const { control } = useFormContext<AppointmentFormFieldData>();

  const activity = useWatch({ name: 'activity', control });
  const start = useWatch({ name: 'start', control });

  const [title, setTitle] = useState('');

  const updateTitle = (activity, start) => {
    const prefix = activity?.name || activity?.code || t('newAppointment');
    setTitle(`${prefix} (${dayjs(start).format('DD-MM')})`);
  };

  useEffect(() => updateTitle(activity, start), [activity, start]);

  return (
    <HeaderContainer>
      <Typography variant="h5">{title}</Typography>
    </HeaderContainer>
  );
};

export default FormHeader;
